import React from "react";
import "./LoadingScreen.css";

function LoadingScreen() {
  return (
    <div className="loading-screen" role="status" aria-live="polite" aria-label="Loading page">
      <div className="loading-screen__orbital" aria-hidden="true">
        <span className="loading-screen__ring loading-screen__ring--outer"></span>
        <span className="loading-screen__ring loading-screen__ring--inner"></span>
        <span className="loading-screen__core"></span>
      </div>

      <div className="loading-screen__text-wrap">
        <h2 className="loading-screen__title">Preparing your experience</h2>
        <p className="loading-screen__subtitle">Please wait a moment</p>
      </div>
    </div>
  );
}

export default LoadingScreen;
